import { render, staticRenderFns } from "./ProfitLossReport.vue?vue&type=template&id=1f340df4&"
import script from "./ProfitLossReport.vue?vue&type=script&lang=js&"
export * from "./ProfitLossReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f340df4')) {
      api.createRecord('1f340df4', component.options)
    } else {
      api.reload('1f340df4', component.options)
    }
    module.hot.accept("./ProfitLossReport.vue?vue&type=template&id=1f340df4&", function () {
      api.rerender('1f340df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ProfitLossReport.vue"
export default component.exports